import { PromoItemRowSchema } from "modules/PromoItems/services/promoItems.schemas";
import moment from "moment";
import {
  IdNamePairSchema,
  IdCodeNamePairSchema,
  ShortUserSchema,
} from "service/generic.schemas";
import * as yup from "yup";

export const MediaFileSchema = yup.object().shape({
  fileId: yup.number().nullable().notRequired(),
  url: yup.string().required(),
  mimeType: yup.string().required(),
  originalFileName: yup.string().required(),
  persistedFileNameInAzureStorage: yup.string().required(),
  uploadedOn: yup.string().required(),
  uploadedBy: ShortUserSchema,
});

export const CreateCampaignSchema = yup.object().shape({
  id: yup.number().nullable().notRequired(),
  name: yup.string().required("This field is required"),
  strategicBuyerEmailAddress: yup
    .string()
    .email("Invalid email format")
    .required("This field is required"),
  description: yup.string().required("This field is required"),
  startDate: yup
    .string()
    .datetime("Enter valid date")
    .required("This field is required"),
  endDate: yup
    .string()
    .datetime("Enter valid date")
    .test(
      "dates-test",
      "Campaign end date should be after campaign start date",
      (value, context) => {
        let startDate = moment(context.parent.startDate).toDate();
        let endDate = moment(value).toDate();
        return endDate > startDate;
      }
    )
    .required("This field is required"),
  validTo: yup
    .string()
    .datetime("Enter valid date")
    .test(
      "dates-test2",
      "Validity end date should be after campaign end date",
      (value, context) => {
        let startDate = moment(context.parent.endDate).toDate();
        let endDate = moment(value).toDate();
        return endDate > startDate;
      }
    )
    .required("This field is required"),
  supplierCode: yup.string().required("This field is required"),
  supplierName: yup.string().required("This field is required"),
  supplierContact: ShortUserSchema,
  agreements: yup.string().nullable().notRequired(),
  //qualityApprovers: yup.array().of(yup.string()).notRequired(),
  // qualityApprovers: yup
  // .array()
  // .of(yup.string())
  // .min(1, "Quality Approver is required"),
  qualityApprovers: yup
  .array()
  .of(
    yup
      .string()
      .email("Invalid email format")
      .required("Email is required")
  )
  .min(1, "Quality Approver is required"),
  zones: yup.array().of(IdNamePairSchema),
  markets: yup.array().of(IdNamePairSchema),
  companyCodes: yup.array().of(IdNamePairSchema),
  incoTerms: yup.string().required("This field is required"),
  spendCategoryL3: IdCodeNamePairSchema.required("This field is required"),
  mediaFiles: yup
    .array()
    .of(MediaFileSchema)
    .min(1, "At least one image is required"),
});

export const CampaignMaterialSchema = PromoItemRowSchema.shape({
  // we're exending existing schema with new fields.
  id: yup.number().nullable().notRequired(),
  longDescription: yup.string().nullable().notRequired(),
  orderWindowId: yup.number().required("This field is required"),
  readOnly: yup.boolean().notRequired().nullable(),
  uoM: yup.string().nullable().notRequired(),
  priceRanges: yup.array().of(
    yup.object().shape({
      threshold: yup
        .number()
        .required("This field is required")
        .min(0.01, "Quantity must be greater than 0")
        .test(
          "threshold",
          "Quantity should be higher or equal to the Minimum Order Quantity (MOQ)",
          (value, context) => {
            return value >= context.from[1].value.minimumOrderQuantity;
          }
        )
        .test(
          "unique-quantity",
          "Quantity values must be unique",
          function (value, context) {
            const quantities = context.from[1].value.priceRanges.map(
              (range) => range.threshold
            );
            return (
              quantities.filter((q) => q?.toString() === value?.toString())
                .length === 1
            );
          }
        )
        .test(
          "multiples-of-mpq",
          "Quantity values must be multiples of Minimum Pack Quantity (MPQ)",
          function (value, context) {
            // const quantities = context.from[1].value.priceRanges.map(
            //   (range) => range.threshold
            // );
            return value % context.from[1].value.minimumPurchaseQuantity === 0;
          }
        ),
      unitPrice: yup
        .number()
        .required("This field is required")
        .min(0.01, "Price must be greater than 0"),
      pricePer: yup
        .number()
        .required("This field is required")
        .integer("Price Per must be an integer")
        .min(1, "Price Per must be greater than 0"),
    })
  ),
});
